import { EventBus } from './event-bus.js';
/**
 * Basic EventDelegator responsible for firing events.
 */
class EventDelegator {
    constructor() {
        this.eventBus = new EventBus();
        this.events = {};
    }
    /**
     * Fires the event.
     *
     * @param type - The event type.
     * @param event - The event data.
     */
    fire(type, event) {
        const eventBusEvents = this.eventBus.get(type);
        if (eventBusEvents) {
            // @ts-ignore: Can't correctly infer the event type.
            eventBusEvents.forEach((fn) => fn(event));
        }
        const callback = this.events[type];
        if (callback) {
            // @ts-ignore: Can't correctly infer the event type.
            callback(event);
        }
    }
}
export { EventDelegator, };
//# sourceMappingURL=event-delegator.js.map